import {createStandardActions, GetActions, placeholder, readonly, standardItemsReducer} from "../../utils";
import {createStandardSelectors, getEntities, selector} from "../../selectors";
import {combineReducers} from "redux";
import {archiveHouse, restoreHouse, upsertHouse} from "../../../api/inventory/inventoryApi";
import {CommonDispatch} from "../../index";

export interface House {
  id: string;
  name: string;
  archivedAt: string | null;
}

const actions = createStandardActions(placeholder<House>(), 'HOUSE/SET', 'HOUSE/SAVE');
const selectors = createStandardSelectors(placeholder<House>(), s => getEntities(s).houses);
export type HouseActions = GetActions<typeof actions>;
export const houses = combineReducers({items: standardItemsReducer<House, HouseActions>(actions)});
export const houseStore = readonly({
  selectors: {
    ...selectors,
    unarchived: selector(s => selectors.getAsArray(s).filter(h => h.archivedAt === null)),
    archived: selector(s => selectors.getAsArray(s).filter(h => h.archivedAt !== null)),
  },
  actions: {
    ...actions,
    upsert: (req: {id: string, name: string, archivedAt?: string | null}) => async (dispatch: CommonDispatch) => {
      const response = await upsertHouse(req);
      dispatch(houseStore.actions.save(response));
    },
    archive: (id: string) => async (dispatch: CommonDispatch) => {
      const response = await archiveHouse(id);
      dispatch(houseStore.actions.save(response));
    },
    restore: (id: string) => async (dispatch: CommonDispatch) => {
      const response = await restoreHouse(id);
      dispatch(houseStore.actions.save(response));
    }
  }
});
